export default __webpack_public_path__ + "static/media/online-reservation.4f1422bf.png";